// DI   HVAC-017
// Progressive enhancement for Career Application Banner

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('careerApplicationModal');
  if (!modal) return;

  // Check if form was successfully submitted and redirect with clean parameter
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;
  
  if (urlParams.get('contact_posted') === 'true' && hash === '#career-application') {
    // Clean redirect with our custom parameter
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('contact_posted');
    cleanUrl.searchParams.set('car', 'sent');
    cleanUrl.hash = '';
    window.history.replaceState({}, '', cleanUrl.toString());
    
    // Show success message
    const successMessage = document.querySelector('.career-app-success');
    if (successMessage) {
      successMessage.classList.add('show');
      
      // Scroll to success message
      setTimeout(() => {
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }

  // Close modal on ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('show')) {
      closeCareerModal();
    }
  });

  // Auto-hide success message after 8 seconds
  const successMessage = document.querySelector('.career-app-success.show');
  if (successMessage) {
    // Scroll to success message
    setTimeout(() => {
      successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
    
    setTimeout(() => {
      successMessage.style.transition = 'opacity 0.5s ease';
      successMessage.style.opacity = '0';
      setTimeout(() => {
        successMessage.classList.remove('show');
        successMessage.style.opacity = '1';
      }, 500);
    }, 8000);
  }

  // Initialize form validation
  initFormValidation();
});

// Form validation for input fields
function initFormValidation() {
  const form = document.querySelector('.career-app-form');
  if (!form) return;

  // Text-only fields (name, city, state, certifications)
  const textOnlyFields = [
    document.getElementById('career_name'),
    document.getElementById('career_city'),
    document.getElementById('career_state'),
    document.getElementById('career_certifications')
  ];

  // Company name field (allows letters, numbers, and common business characters)
  const companyField = document.getElementById('career_company');

  // Number-only fields (phone, years of experience)
  const numberOnlyFields = [
    document.getElementById('career_phone'),
    document.getElementById('career_experience')
  ];

  // Apply text-only validation (letters, spaces, hyphens, apostrophes only)
  textOnlyFields.forEach(field => {
    if (!field) return;
    
    field.addEventListener('input', function(e) {
      // Allow only letters, spaces, hyphens, and apostrophes
      this.value = this.value.replace(/[^a-zA-Z\s\-']/g, '');
    });

    field.addEventListener('keypress', function(e) {
      const char = String.fromCharCode(e.which);
      // Prevent input of numbers and special characters (except space, hyphen, apostrophe)
      if (!/[a-zA-Z\s\-']/.test(char)) {
        e.preventDefault();
      }
    });
  });

  // Apply company name validation (letters, numbers, spaces, and common business characters)
  if (companyField) {
    companyField.addEventListener('input', function(e) {
      // Allow letters, numbers, spaces, hyphens, apostrophes, periods, ampersands, commas
      this.value = this.value.replace(/[^a-zA-Z0-9\s\-'.&,]/g, '');
    });

    companyField.addEventListener('keypress', function(e) {
      const char = String.fromCharCode(e.which);
      // Prevent input of special characters except allowed ones
      if (!/[a-zA-Z0-9\s\-'.&,]/.test(char)) {
        e.preventDefault();
      }
    });
  }

  // Apply number-only validation (digits, spaces, hyphens, parentheses, plus sign)
  numberOnlyFields.forEach(field => {
    if (!field) return;
    
    field.addEventListener('input', function(e) {
      // For phone: allow digits, spaces, hyphens, parentheses, and plus sign
      // For experience: allow only digits
      if (field.id === 'career_phone') {
        this.value = this.value.replace(/[^0-9\s\-\(\)\+]/g, '');
      } else {
        this.value = this.value.replace(/[^0-9]/g, '');
      }
    });

    field.addEventListener('keypress', function(e) {
      const char = String.fromCharCode(e.which);
      // Prevent input of letters and special characters
      if (field.id === 'career_phone') {
        if (!/[0-9\s\-\(\)\+]/.test(char)) {
          e.preventDefault();
        }
      } else {
        if (!/[0-9]/.test(char)) {
          e.preventDefault();
        }
      }
    });
  });

  // Add form submit validation
  form.addEventListener('submit', function(e) {
    let isValid = true;
    let errorMessage = '';

    // Validate name field
    const nameField = document.getElementById('career_name');
    if (nameField && !/^[a-zA-Z\s\-']+$/.test(nameField.value.trim())) {
      isValid = false;
      errorMessage += 'Name should contain only letters.\n';
    }

    // Validate city field
    const cityField = document.getElementById('career_city');
    if (cityField && !/^[a-zA-Z\s\-']+$/.test(cityField.value.trim())) {
      isValid = false;
      errorMessage += 'City should contain only letters.\n';
    }

    // Validate state field
    const stateField = document.getElementById('career_state');
    if (stateField && !/^[a-zA-Z\s\-']+$/.test(stateField.value.trim())) {
      isValid = false;
      errorMessage += 'State should contain only letters.\n';
    }

    // Validate company name field
    const companyField = document.getElementById('career_company');
    if (companyField && companyField.value.trim() && !/^[a-zA-Z0-9\s\-'.&,]+$/.test(companyField.value.trim())) {
      isValid = false;
      errorMessage += 'Company Name contains invalid characters.\n';
    }

    // Validate phone field
    const phoneField = document.getElementById('career_phone');
    if (phoneField && !/^[0-9\s\-\(\)\+]+$/.test(phoneField.value.trim())) {
      isValid = false;
      errorMessage += 'Phone should contain only numbers.\n';
    }

    // Validate years of experience field
    const expField = document.getElementById('career_experience');
    if (expField && !/^[0-9]+$/.test(expField.value.trim())) {
      isValid = false;
      errorMessage += 'Years of Experience should contain only numbers.\n';
    }

    if (!isValid) {
      e.preventDefault();
      alert(errorMessage.trim());
    }
  });
}

function openCareerModal() {
  const modal = document.getElementById('careerApplicationModal');
  if (modal) {
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
}

function closeCareerModal(event) {
  const modal = document.getElementById('careerApplicationModal');
  const modalContent = document.querySelector('.career-app-modal-content');
  
  // If event is provided, check if click was outside modal content
  if (event && event.target !== modal) {
    return;
  }
  
  if (modal) {
    modal.classList.remove('show');
    document.body.style.overflow = '';
  }
}
